// import React, { Component } from "react";
import React from "react";
import ChangePassword from "./ChangePassword/ChangePassword";
import Department from "./Department/Department";
import Location from "./Location/Location";
import Organisation from "./Organisation/Organisation";
interface Props {
  pageStatus: string;
}

const Setting: React.FC<Props> = ({ pageStatus }) => {
  const updateMasterState = (
    attrName: any,
    value: string | boolean | number
  ) => {
    attrName(value);
  };
  const [addNewDepartment, setAddNewDepartment] = React.useState(false);
  const [locationStatus, setLocationStatus] = React.useState(false);
  return (
    <div>
      {pageStatus === "organisation" ? <Organisation /> : null}
      {pageStatus === "department" ? (
        <Department
          attrName={setAddNewDepartment}
          open_status={addNewDepartment}
          value_update={updateMasterState}
        />
      ) : null}
      {pageStatus === "location" ? (
        <Location
          attrName={setLocationStatus}
          open_status={locationStatus}
          value_update={updateMasterState}
        />
      ) : null}

      {/* {pageStatus === "location" ? <Location /> : null} */}
      {pageStatus === "password" ? <ChangePassword /> : null}
    </div>
  );
};

export default Setting;
